var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.8758,
    y1: 411.5345,
    x2: 199.9109,
    y2: 180.0346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9C7FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M131.279,111.469l76.588,34.104c5.342,2.379,9.604,10.705,9.604,18.634v240.256 c0,7.93-4.262,14.358-9.604,14.358h-76.588c-6.886,0-12.569-7.479-12.569-16.705V122.578 C118.71,113.352,124.393,108.403,131.279,111.469z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022533199627584495880000003040267215951261838_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.5154,
    y1: -711.4829,
    x2: 293.0398,
    y2: -711.4829,
    gradientTransform: "matrix(0.8578 -0.514 0.514 0.8578 277.7682 1108.2791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8BFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6173,
    style: {
      stopColor: "#B4B4FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022533199627584495880000003040267215951261838_)"
    },
    d: "M115.726,343.451 c-2.974,0.206-5.578,1.253-7.876,3.253c-1.795,1.562-7.321,7.521-9.849,7.25c1.821,0.195,3.667,0.396,5.377,1.052 c5.194,1.992,2.994,6.666,6.414,9.949c1.462,1.403,3.661,1.81,5.67,1.542c2.009-0.268,3.884-1.127,5.724-1.975 c0.762,1.581-0.53,3.44-2.055,4.31c-1.524,0.869-3.336,1.222-4.713,2.309c1.487,3.425,4.079,7.232,7.805,6.998 c4.218-0.265,6.328-5.462,10.23-7.086c0.563-0.234,1.285-0.361,1.722,0.064c0.511,0.496,0.266,1.353-0.055,1.99 c-1.957,3.883-5.564,6.899-9.732,8.138c1.738,1.966,3.918,3.638,6.458,4.296c2.54,0.659,5.468,0.163,7.337-1.679 c1.999-1.97,2.499-5.061,4.381-7.144c0.607-0.672,1.505-1.254,2.371-0.99c0.717,0.219,1.153,0.95,1.374,1.667 c0.685,2.219-0.083,4.682-1.451,6.559c-1.368,1.877-3.274,3.279-5.149,4.649c5.938,0.539,12.243,0.022,17.269-3.186 c5.026-3.209,8.305-9.67,6.384-15.315c-0.754-2.217-2.131-4.464-1.575-6.902c0.458-2.007,2.078-3.618,2.632-5.64 c1.461-5.33-0.728-11.528-4.689-15.227c-3.669-3.427-9.006-4.977-13.939-4.049c3.037,1.636,5.517,4.284,6.951,7.421 c0.406,0.887,0.735,1.859,0.584,2.822c-0.151,0.963-0.922,1.888-1.896,1.914c-1.277,0.034-2.086-1.319-2.613-2.483 c-1.558-3.446-2.787-6.73-6.709-7.949c-2.492-0.774-5.161-0.71-7.765-0.538c1.475,1.436,2.572,3.258,3.15,5.233 c0.296,1.011,2.176,4.062,0.286,4.617c-0.609,0.179-1.188-0.351-1.574-0.859c-1.235-1.624-2.086-3.511-3.287-5.161 c-2.036-2.797-4.995-4.296-8.356-3.426c-0.424,0.11-3.202,1.712-3.197,1.714c2.823,0.968,5.048,3.508,5.637,6.433 c0.041,0.206,0.074,0.426-0.007,0.62c-0.153,0.369-0.636,0.471-1.032,0.417c-1.937-0.263-2.707-2.601-4.099-3.973 c-1.121-1.105-2.732-1.596-4.305-1.661C116.934,343.402,116.322,343.409,115.726,343.451z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M105.647,354.251c14.064,0.889,28.219,2.461,41.768,6.499 c13.575,4.045,26.691,10.769,35.298,22.365c5.975,8.05,9.658,17.29,12.469,26.842c0.173,0.588,1.069,0.343,0.919-0.253 c-2.159-8.615-5.602-17.101-10.486-24.539c-4.031-6.138-9.185-11.309-15.275-15.406c-12.094-8.135-26.663-11.951-40.924-14.06 c-7.877-1.165-15.819-1.819-23.767-2.244C105.134,353.427,105.138,354.219,105.647,354.251L105.647,354.251z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.75,370.906c2.945-1.127,5.252-3.204,7.417-5.438c1.14-1.176,2.242-2.39,3.42-3.527 c1.368-1.321,3.072-3.086,5.065-3.229c0.503-0.036,0.636-0.748,0.122-0.899c-5.73-1.687-7.353-8.28-11.013-12.279 c-0.37-0.404-0.935,0.185-0.594,0.594c3.57,4.282,5.498,10.805,11.364,12.567c0.041-0.3,0.081-0.599,0.122-0.899 c-3.194,0.203-5.849,3.539-7.881,5.703c-2.425,2.583-4.865,5.29-8.237,6.619C122.052,370.309,122.257,371.095,122.75,370.906 L122.75,370.906z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M133.77,380.065c4.167-1.349,5.183-5.905,6.433-9.565c1.545-4.523,5.002-7.899,9.757-8.854 c0.399-0.08,0.419-0.634,0.108-0.826c-5.095-3.168-5.127-10.006-7.916-14.767c-0.272-0.465-0.978-0.051-0.722,0.422 c2.711,5.001,2.904,11.856,8.182,15.126c0.036-0.276,0.072-0.551,0.108-0.826c-3.84,0.777-7.272,3.212-9.169,6.66 c-2.136,3.882-2.103,10.154-6.996,11.852C133.067,379.455,133.27,380.227,133.77,380.065L133.77,380.065z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M150.45,382.38c3.019-1.172,5.757-3.492,6.778-6.644c1.13-3.491-0.822-9.466,3.455-11.289 c0.324-0.138,0.257-0.614,0-0.771c-3.655-2.24-1.575-7.332-1.567-10.699c0.008-3.244-1.086-6.444-3.101-8.985 c-0.284-0.358-0.905,0.116-0.638,0.492c2.555,3.604,3.145,7.411,2.533,11.719c-0.417,2.937-0.553,6.48,2.322,8.243 c0-0.257,0-0.514,0-0.771c-3.394,1.445-3.307,5.531-3.398,8.622c-0.066,2.231-0.564,4.264-2.014,6.009 c-1.261,1.516-2.893,2.551-4.673,3.354C149.746,381.844,150.034,382.542,150.45,382.38L150.45,382.38z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029747515249114990060000011511974111713496487_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.608,
    y1: 782.2886,
    x2: 321.992,
    y2: 782.2886,
    gradientTransform: "matrix(0.9708 0.2398 -0.2398 0.9708 65.2096 -513.8517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#433EBD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029747515249114990060000011511974111713496487_)"
    },
    d: "M150.816,276.729 c-2.855-2.469-6.13-3.852-9.98-4.107c-3.007-0.199-13.29,0.223-15.319-2.275c1.462,1.801,2.941,3.628,3.892,5.744 c2.889,6.425-3.259,8.661-3.116,14.663c0.061,2.565,1.674,4.894,3.718,6.446c2.044,1.552,4.495,2.453,6.906,3.333 c-0.726,2.1-3.547,2.618-5.692,2.038c-2.145-0.579-4.088-1.88-6.296-2.132c-1.721,4.404-2.789,10.138,0.767,13.253 c4.026,3.527,10.56,0.74,15.515,2.764c0.715,0.292,1.477,0.822,1.491,1.594c0.016,0.902-0.969,1.453-1.825,1.738 c-5.224,1.742-11.157,1.233-16.008-1.373c-0.193,3.318,0.273,6.765,1.968,9.624c1.694,2.859,4.767,5.027,8.091,5.039 c3.554,0.014,6.763-2.317,10.312-2.509c1.145-0.062,2.472,0.216,3.014,1.227c0.449,0.837,0.188,1.883-0.253,2.725 c-1.366,2.605-4.253,4.133-7.157,4.599c-2.904,0.466-5.868,0.024-8.776-0.418c4.854,5.784,10.981,10.947,18.36,12.549 c7.379,1.602,16.093-1.276,19.404-8.063c1.301-2.665,2.069-5.913,4.745-7.607c2.203-1.394,5.096-1.396,7.398-2.718 c6.07-3.485,9.634-11.008,9.377-17.866c-0.238-6.353-3.65-12.509-8.911-16.078c1.268,4.18,1.134,8.773-0.377,12.871 c-0.427,1.159-0.999,2.327-1.995,3.057c-0.996,0.73-2.513,0.874-3.412,0.027c-1.178-1.109-0.698-3.047-0.131-4.563 c1.676-4.487,3.503-8.534,1.066-13.13c-1.549-2.92-4.003-5.244-6.497-7.413c0.044,2.607-0.597,5.222-1.84,7.514 c-0.636,1.173-1.67,5.591-3.864,4.404c-0.708-0.383-0.754-1.376-0.648-2.176c0.34-2.562,1.259-5.017,1.653-7.572 c0.667-4.33-0.654-8.317-4.45-10.535c-0.479-0.28-4.405-1.319-4.402-1.314c1.673,3.389,1.405,7.657-0.677,10.811 c-0.146,0.222-0.314,0.449-0.559,0.552c-0.467,0.195-0.992-0.145-1.299-0.546c-1.505-1.965-0.111-4.753-0.137-7.228 c-0.021-1.993-1.03-3.873-2.386-5.334C151.945,277.763,151.389,277.224,150.816,276.729z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M132.195,277.362c11.778,13.265,22.095,27.736,30.925,43.117 c9.179,15.988,16.346,32.903,22.243,50.351c3.486,10.316,6.468,20.778,9.693,31.175c0.181,0.584,1.082,0.341,0.919-0.253 c-5.106-18.622-10.805-37.254-18.398-55.027c-7.007-16.404-15.76-32.049-26.096-46.587 c-5.783-8.134-12.039-15.928-18.724-23.339C132.414,276.416,131.856,276.98,132.195,277.362L132.195,277.362z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M132.672,307.569c3.838,1.696,7.972,1.798,12.102,1.697c2.21-0.054,4.421-0.165,6.632-0.08 c2.152,0.083,4.785,0.121,6.474,1.63c0.382,0.342,0.977-0.087,0.719-0.555c-3.671-6.644,0.772-14.041,1.059-20.916 c0.023-0.545-0.796-0.532-0.84,0c-0.58,7.002-4.717,14.596-1.01,21.379c0.24-0.185,0.479-0.37,0.719-0.555 c-1.376-1.245-3.144-1.571-4.936-1.763c-2.192-0.235-4.404-0.197-6.604-0.129c-4.677,0.146-9.499,0.493-13.902-1.412 C132.608,306.658,132.19,307.356,132.672,307.569L132.672,307.569z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M134.398,325.634c5.039,2.57,10.104-0.878,14.563-3.032c5.333-2.576,11.443-2.39,16.429,0.92 c0.344,0.228,0.751-0.148,0.664-0.511c-1.774-7.423,4.321-13.591,6.075-20.382c0.135-0.521-0.658-0.74-0.806-0.222 c-1.979,6.91-7.974,13.213-6.141,20.844c0.221-0.17,0.443-0.34,0.664-0.511c-4.197-2.78-9.578-3.625-14.401-2.104 c-5.271,1.663-10.818,7.147-16.64,4.298C134.342,324.708,133.932,325.396,134.398,325.634L134.398,325.634z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M147.317,342.603c3.996,1.727,8.901,2.021,12.699-0.375c3.731-2.354,7.268-8.731,12.476-6.627 c0.332,0.134,0.623-0.251,0.549-0.549c-1.322-5.306,5.084-8.056,8.132-11.083c2.902-2.882,4.786-6.732,5.249-10.794 c0.051-0.451-0.727-0.56-0.798-0.108c-0.784,4.986-3.311,9.118-7.309,12.177c-3.167,2.423-7.272,5.472-6.135,10.045 c0.183-0.183,0.366-0.366,0.549-0.549c-4.408-1.782-7.993,2.196-10.869,4.896c-1.933,1.815-4.103,3.084-6.775,3.392 c-2.565,0.296-5.079-0.229-7.467-1.143C147.209,341.728,146.909,342.427,147.317,342.603L147.317,342.603z"
  }))))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000021093090122829476100000014513001827253256338_",
    cx: 1036.4281,
    cy: -331.1366,
    r: 83.1802,
    gradientTransform: "matrix(2.6803 0 0 0.3508 -2527.938 534.984)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8DAEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000021093090122829476100000014513001827253256338_)"
    },
    cx: 250,
    cy: 418.821,
    rx: 222.955,
    ry: 29.179
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036215570812871176240000010448201660726323848_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.9074,
    y1: 348.2498,
    x2: 307.9074,
    y2: 61.6515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9C7FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036215570812871176240000010448201660726323848_)"
    },
    d: "M351.709,418.821V56.045 c0-8.632-8.856-14.428-16.767-10.974l-52.62,22.976c-11.065,4.831-18.216,15.757-18.216,27.831v322.944H351.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115510106493734161210000011065985976325550465_",
    gradientUnits: "userSpaceOnUse",
    x1: 2913.6313,
    y1: 417.3141,
    x2: 2980.8262,
    y2: 240.6164,
    gradientTransform: "matrix(-1 0 0 1 3299.457 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9C7FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115510106493734161210000011065985976325550465_)"
    },
    d: "M380.535,189.421l-79.444,25.454 c-5.541,1.775-9.962,7.99-9.962,13.908v179.321c0,5.918,4.421,10.716,9.962,10.716h79.444c7.142,0,13.038-5.582,13.038-12.468 v-208.64C393.573,190.826,387.677,187.133,380.535,189.421z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014634714777560652820000014274270174841476764_",
    gradientUnits: "userSpaceOnUse",
    x1: 2689.4146,
    y1: 413.1606,
    x2: 2709.2957,
    y2: 413.1606,
    gradientTransform: "matrix(-1 0 0 1 2892.4001 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    style: {
      stopColor: "#343B97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5457D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014634714777560652820000014274270174841476764_)"
    },
    d: "M184.244,407.5l-1.14,11.321h19.881 v-3.02c-0.458-1.119-6.633-5.504-7.788-8.301C188.546,407.5,184.244,407.5,184.244,407.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148647265776244025420000001764885735167392150_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.3737,
    y1: 263.9721,
    x2: 336.8385,
    y2: 263.9721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148647265776244025420000001764885735167392150_)"
    },
    d: "M318.073,418.821H210.139 c-10.364,0-18.765-8.401-18.765-18.765V127.888c0-10.364,8.402-18.765,18.765-18.765h107.934 c10.364,0,18.765,8.402,18.765,18.765v272.168C336.839,410.42,328.437,418.821,318.073,418.821z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049929801094345788550000016854266276166207155_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.7269,
    y1: 454.8044,
    x2: 196.1588,
    y2: 60.7377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    style: {
      stopColor: "#343B97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46C8FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049929801094345788550000016854266276166207155_)"
    },
    d: "M312.823,418.821H204.889 c-10.364,0-18.765-8.401-18.765-18.765V127.888c0-10.364,8.402-18.765,18.765-18.765h107.934 c10.364,0,18.765,8.402,18.765,18.765v272.168C331.588,410.42,323.187,418.821,312.823,418.821z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051378014971299986430000014568044845131272373_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.4008,
    y1: 412.0157,
    x2: 259.4008,
    y2: 134.1484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#433EBD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051378014971299986430000014568044845131272373_)"
    },
    d: "M326.991,133.37v259.809 c0,4.4-3.56,7.96-7.96,7.96h-119.26c-4.4,0-7.96-3.56-7.96-7.96V133.37c0-4.4,3.56-7.97,7.96-7.97h45.8 c3.14,0,6.21,1.25,8.23,3.64c1.34,1.6,3.35,2.61,5.6,2.61s4.26-1.01,5.6-2.61c2.02-2.39,5.09-3.64,8.24-3.64h45.79 C323.431,125.4,326.991,128.97,326.991,133.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004515081972306397740000006752905334016442264_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.3817,
    y1: 101.5222,
    x2: 258.3817,
    y2: 142.5222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000004515081972306397740000006752905334016442264_)"
    },
    cx: 258.856,
    cy: 123.079,
    r: 3.664
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106116885684885762760000011637588645001992833_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.8559,
    y1: 158.5,
    x2: 258.8559,
    y2: 137.9999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000106116885684885762760000011637588645001992833_)"
    },
    cx: 258.856,
    cy: 123.079,
    r: 1.695
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 260.719,
    cy: 197.66,
    r: 5.915
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "206.245,178.4 315.341,178.4 315.193,253.107 206.097,253.107  "
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 206.2432 184.4127)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px",
      letterSpacing: 51
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 16.068,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 17.808,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px",
      letterSpacing: 51
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 36.29,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.504,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.718,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.931,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 101.139,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.92,
    y: 15.792,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.076,
    y: 15.792,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.29,
    y: 15.792,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.504,
    y: 15.792,
    style: {
      fill: "#3656C9",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "9"), /*#__PURE__*/React.createElement("tspan", {
    x: 66.744,
    y: 15.792,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "10"), /*#__PURE__*/React.createElement("tspan", {
    x: 82.958,
    y: 15.792,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.149,
    y: 15.792,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "12"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.931,
    y: 31.583,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "13"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.104,
    y: 31.583,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "14"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.316,
    y: 31.583,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "15"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.53,
    y: 31.583,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "16"), /*#__PURE__*/React.createElement("tspan", {
    x: 66.744,
    y: 31.583,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "17"), /*#__PURE__*/React.createElement("tspan", {
    x: 82.958,
    y: 31.583,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "18"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.134,
    y: 31.583,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "19"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.915,
    y: 47.375,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "20"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.104,
    y: 47.375,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "21"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.316,
    y: 47.375,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "22"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.53,
    y: 47.375,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "23"), /*#__PURE__*/React.createElement("tspan", {
    x: 66.744,
    y: 47.375,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "24"), /*#__PURE__*/React.createElement("tspan", {
    x: 82.958,
    y: 47.375,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "25"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.118,
    y: 47.375,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "26"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.899,
    y: 63.167,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "27"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.104,
    y: 63.167,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "28"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.316,
    y: 63.167,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "29"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.53,
    y: 63.167,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "30"), /*#__PURE__*/React.createElement("tspan", {
    x: 66.744,
    y: 63.167,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "7.0272px"
    }
  }, "31"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 205.9961 156.0659)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Bold'",
      fontSize: "7.7607px"
    }
  }, "JANUARY"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 203.606,
    y: 165.923,
    style: {
      fill: "none"
    },
    width: 113.374,
    height: 12.477
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 206.1973 169.6793)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "4.392px"
    }
  }, "SUN"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.901,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "4.392px"
    }
  }, "MON"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.513,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "4.392px"
    }
  }, "TUE"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.46,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "4.392px"
    }
  }, "WED"), /*#__PURE__*/React.createElement("tspan", {
    x: 66.397,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "4.392px"
    }
  }, "THU"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.136,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "4.392px"
    }
  }, "FRI"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.854,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Roboto-Regular'",
      fontSize: "4.392px"
    }
  }, "SAT")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024692479664889110890000015681873022073390489_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.719,
    y1: 310.0934,
    x2: 260.719,
    y2: 271.3596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024692479664889110890000015681873022073390489_)"
    },
    d: "M310.991,281.434H210.446 c-4.039,0-7.312-3.274-7.312-7.313v-6.326c0-4.039,3.274-7.313,7.312-7.313h100.545c4.039,0,7.313,3.274,7.313,7.313v6.326 C318.304,278.16,315.03,281.434,310.991,281.434z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 286.8612 272.3521)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "5.2002px"
    }
  }, "08.00 AM"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 209.0458 272.6529)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "6.2538px"
    }
  }, "Go to Work"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073697450754499946480000001113731705192864426_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.719,
    y1: 337.4462,
    x2: 260.719,
    y2: 298.7121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073697450754499946480000001113731705192864426_)"
    },
    d: "M310.991,308.787H210.446 c-4.039,0-7.312-3.274-7.312-7.313v-6.326c0-4.039,3.274-7.313,7.312-7.313h100.545c4.039,0,7.313,3.274,7.313,7.313v6.326 C318.304,305.513,315.03,308.787,310.991,308.787z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 286.8612 299.7047)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "5.2002px"
    }
  }, "08.30 AM")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 209.0458 300.0055)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "6.2538px"
    }
  }, "Meeting")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182504323571127895030000017486823401763841451_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.719,
    y1: 364.7988,
    x2: 260.719,
    y2: 326.0647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182504323571127895030000017486823401763841451_)"
    },
    d: "M310.991,336.139H210.446 c-4.039,0-7.312-3.274-7.312-7.313v-6.326c0-4.039,3.274-7.313,7.312-7.313h100.545c4.039,0,7.313,3.274,7.313,7.313v6.326 C318.304,332.865,315.03,336.139,310.991,336.139z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 286.8612 327.0572)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "5.2002px"
    }
  }, "11.00 AM")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 209.0458 327.358)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "6.2538px"
    }
  }, "Inspection")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023274522086612351850000008299254494620040362_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.719,
    y1: 392.1513,
    x2: 260.719,
    y2: 353.4172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023274522086612351850000008299254494620040362_)"
    },
    d: "M310.991,363.492H210.446 c-4.039,0-7.312-3.274-7.312-7.313v-6.326c0-4.039,3.274-7.313,7.312-7.313h100.545c4.039,0,7.313,3.274,7.313,7.313v6.326 C318.304,360.218,315.03,363.492,310.991,363.492z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 286.8612 354.4098)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "5.2002px"
    }
  }, "12.00 AM")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 209.0458 354.7105)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "6.2538px"
    }
  }, "Lunch")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008859149623569146280000010525192822544260747_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.719,
    y1: 419.5039,
    x2: 260.719,
    y2: 380.7698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008859149623569146280000010525192822544260747_)"
    },
    d: "M310.991,390.845H210.446 c-4.039,0-7.312-3.274-7.312-7.313v-6.326c0-4.039,3.274-7.313,7.312-7.313h100.545c4.039,0,7.313,3.274,7.313,7.313v6.326 C318.304,387.57,315.03,390.845,310.991,390.845z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 286.9803 381.7623)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "5.2002px"
    }
  }, "01.00 PM")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 209.0458 382.0631)",
    style: {
      fill: "#312E6D",
      fontFamily: "'OpenSans-Semibold'",
      fontSize: "6.2538px"
    }
  }, "Back to Office")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148627661631131511770000000572819135258773911_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.9116,
    y1: 337.3588,
    x2: 375.9116,
    y2: 373.7338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5D3AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148627661631131511770000000572819135258773911_)"
    },
    d: "M386.068,412.364 c-0.529,0.531-1.106,1.009-1.721,1.426c-2.145,1.455-5.896,4.254-8.592,4.002c-2.026-0.187-3.824,0.542-5.869,0.325 c-1.212-0.128-2.423-0.256-3.644-0.374c-1.013-0.108-2.243-0.365-2.745-1.35c-0.435-0.857,0-1.813,0.691-2.267 c0.691-0.444,1.581-0.532,2.404-0.71c2.168-0.483,4.184-1.577,6.001-3.036c3.351-2.691,6.039-6.623,7.724-10.171l-7.09-69.229 c0,0,15.182,0,15.211,0c-1.268,0-0.871,14.488-0.691,15.868c0.899,6.761,3.124,13.522,3.351,20.274 c0.104,3.016-0.208,5.953-0.521,8.89c-0.814,7.629-1.174,15.316-1.77,22.935c-0.202,2.555,0.923,4.948,0.454,7.435 C388.831,408.67,387.671,410.756,386.068,412.364z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161629289915525766950000017583403523418760118_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.3227,
    y1: 410.5418,
    x2: 389.807,
    y2: 410.5418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161629289915525766950000017583403523418760118_)"
    },
    d: "M388.62,417.818 c-0.021,0.088-0.041,0.176-0.062,0.263c-0.584-0.166-1.196-0.225-1.799-0.175c0.248-1.195,0.895-4.882-0.506-5.129 c-0.791-0.14-2.861,1.582-3.542,1.983c-2.416,1.422-5.007,3.371-7.805,3.814c-1.311,0.208-2.648,0.056-3.966-0.096 c-1.739-0.201-6.465-0.166-7.443-2.086c-0.435-0.857,0-1.813,0.691-2.267c0.691-0.444,1.581-0.532,2.404-0.71 c2.168-0.483,4.184-1.577,6.001-3.036c1.306,0.345,2.849,0.532,4.496,0.266c4.496-0.739,5.916-1.971,11.851-8.24l0.047,0.049 c0.328,2.604,0.954,4.695,0.794,7.361C389.619,412.513,389.231,415.193,388.62,417.818z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033345235957180158360000003711177593311088028_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.1637,
    y1: 318.9258,
    x2: 354.0387,
    y2: 360.1758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5D3AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033345235957180158360000003711177593311088028_)"
    },
    d: "M367.901,346.849 c0.263,6.761,1.852,13.522,1.452,20.274c-0.18,3.016-0.772,5.953-1.364,8.89c-1.528,7.629-2.617,15.316-3.918,22.935 c-0.012,0-0.552,7.811-0.832,8.485c-0.685,1.649-2.534,2.317-3.788,3.531c-0.981,0.95-1.602,2.248-2.578,3.203 c-1.56,1.525-5.353,3.838-7.635,3.626c-2.009-0.187-3.875,0.542-5.895,0.325c-1.201-0.128-2.401-0.256-3.611-0.374 c-1.001-0.108-2.219-0.365-2.621-1.35c-0.347-0.857,0.17-1.813,0.908-2.267c0.729-0.444,1.623-0.532,2.473-0.71 c2.344-0.513,4.597-1.715,6.654-3.322c3.448-2.681,6.353-6.456,8.306-9.886l-0.577-69.229c0,0,15.183,0,15.211,0 C368.817,330.98,367.852,345.469,367.901,346.849z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106128893380035501090000002841676622798491285_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.1657,
    y1: 410.619,
    x2: 377.41,
    y2: 410.619,
    gradientTransform: "matrix(1 0 0.0653 1 -39.768 1.000000e-04)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106128893380035501090000002841676622798491285_)"
    },
    d: "M363.6,418.717 c0.003,0.034,0.007,0.068,0.01,0.102c-0.644,0.001-1.288,0.001-1.931,0.002c-0.07-1.648,0.211-5.854-1.395-6.068 c-0.883-0.118-2.673,1.375-3.399,1.78c-3.549,1.983-6.358,4.495-10.748,4.118c-2.391-0.205-5.016-0.524-7.339-1.275 c-0.747-0.241-1.506-0.623-1.962-1.297c-0.455-0.673-0.48-1.694,0.117-2.155c0.25-0.193,0.568-0.267,0.877-0.337 c3.485-0.789,6.464-1.266,9.315-3.493c1.49,0.513,3.406,0.887,5.43,0.552c4.45-0.739,5.792-1.971,11.344-8.23 c0.058,1.961,0.289,3.403-0.022,5.346C363.326,411.346,363.225,415.042,363.6,418.717z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037688747030267440930000010083261545004183207_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.0351,
    y1: 214.6365,
    x2: 368.0497,
    y2: 214.6365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037688747030267440930000010083261545004183207_)"
    },
    d: "M362.778,201.225 c-0.562-0.046-23.993,11.527-28.493,12.527s-35.75-6.263-35.75-6.263s-2.5,6.513-2.5,8.763c16,6.5,35,11,38.5,11.75 s25.419-7.75,30.46-11.25S368.521,201.698,362.778,201.225z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127749405126145753300000012714783715799181462_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.6544,
    y1: 209.6588,
    x2: 299.6131,
    y2: 209.6588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5D3AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127749405126145753300000012714783715799181462_)"
    },
    d: "M299.312,209.659 c-0.927-0.154-2.454-0.408-2.454-0.408s-3.202-3.178-4.465-3.572c-1.264-0.394-4.381-1.144-5.645-1.738 c-1.264-0.594-1.011,0.585-0.337,1.344c0.674,0.758,2.949,2.1,2.949,2.1c-2.851-0.871-5.69-1.77-8.531-2.672 c-0.235-0.075-0.477-0.15-0.723-0.136c-0.246,0.014-0.502,0.136-0.604,0.361c-0.035,0.077-0.052,0.164-0.109,0.226 c-0.125,0.134-0.345,0.067-0.515-0.003c-0.603-0.249-1.158-0.582-1.224,0.255c-0.015,0.188,0.52,1.407,0.713,1.055 c-0.394,0.721,0.239,1.557,0.825,2.133c0.781,0.767,1.573,1.544,2.524,2.086c-0.736-0.109-1.473-0.219-2.209-0.328 c-0.25,0.876,0.726,1.58,1.564,1.938c3.003,1.282,6.128,1.951,9.347,2.388c0.548,0.074,7.063,0.254,7.03,0.85 C298.23,215.529,300.404,209.66,299.312,209.659z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092454826265470870730000001515797688574817463_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.6385,
    y1: 207.9427,
    x2: 366.201,
    y2: 243.7551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8BFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6173,
    style: {
      stopColor: "#B4B4FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092454826265470870730000001515797688574817463_)"
    },
    d: "M380.4,201.7 c-1.75,4.46-9.53,24.01-15.51,33.11c-1.29-6.55-0.26-29.09-0.04-33.62c2.51-0.08,5.12,0.19,7.61,0.24 c3.67,0.07,7.07,0.14,7.08,0.14C379.81,201.57,380.1,201.62,380.4,201.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102502547908368128240000000350124327717335484_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.9187,
    y1: 306.263,
    x2: 395.5569,
    y2: 306.263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102502547908368128240000000350124327717335484_)"
    },
    d: "M353.66,278.74 c0,0-5.107,46.076-4.721,57.269c17.386,8.33,45.025,0.521,45.025,0.521s-0.946-15.098,0-23.168 c0.946-8.07,3.054-17.701,0-26.031c-3.054-8.33-4.554-14.657-4.554-14.657L353.66,278.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155141862172571936010000018012580012312802223_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.9394,
    y1: 248.89,
    x2: 396.4104,
    y2: 248.89
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155141862172571936010000018012580012312802223_)"
    },
    d: "M396.38,289.78 c-0.01,0.46-0.02,0.95-0.28,1.33c-0.21,0.29-0.53,0.48-0.84,0.65c-0.3,0.16-0.6,0.32-0.9,0.47c-7.83,3.86-17.06,3.74-25.84,3.51 c-1.6-4.99-2.27-10.27-1.96-15.49c-3.2,4.71-2.11,11.19-4.56,16.34c-4.35-0.67-8.68-1.54-12.95-2.6 c-1.14-18.31,7.02-35.51,1.92-53.74c-1.57-5.58-2.53-10.21-0.5-15.79c2.12-5.84,5.15-11.49,7.69-17.16 c0.02-0.04,0.03-0.07,0.05-0.11c0.14-0.32,0.28-0.64,0.42-0.96c1.05-2.4,2.19-4.75,5.01-4.98c0.12-0.01,0.23-0.02,0.35-0.02 c0.28-0.03,0.57-0.04,0.86-0.04c-0.22,4.53-1.25,27.07,0.04,33.62c5.98-9.1,13.76-28.65,15.51-33.11 c0.29,0.07,0.58,0.17,0.87,0.28c0.76,0.27,1.52,0.63,2.18,0.8c2,0.52,3.92,1.07,5.72,2.16c4.86,2.97,4.47,10.09,4.57,15.22 c0.16,8.14-1,16.29-3.23,24.11c-1.88,6.56-1.79,13.95,0.79,20.33c0.82,2.02,1.92,3.92,2.75,5.93 C396.52,276.55,396.47,283.27,396.38,289.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087399997187851930570000017010831720441639095_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.2693,
    y1: 181.0052,
    x2: 377.9781,
    y2: 181.0052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087399997187851930570000017010831720441639095_)"
    },
    d: "M375.603,166.562 c-0.951-1.483-3.159-3.438-4.87-3.954c-0.717-0.217-1.478-0.232-2.21-0.39c-0.455-0.099-0.905-0.254-1.371-0.247 c-0.45,0.007-0.883,0.164-1.305,0.319c-5.288,1.946-10.273,5.169-9.601,11.587c0.219,2.088,1.077,4.048,1.626,6.075 c0.869,3.204,0.955,6.652,0.005,9.833c-1.02,3.418-3.227,6.775-2.445,10.255c0.61-1.311,2-2.103,3.404-2.451 c1.404-0.347,2.869-0.333,4.305-0.505c5.748-0.688,10.998-4.613,13.284-9.932c2.04-4.748,1.76-10.164,0.905-15.261 C377.02,170.037,376.618,168.145,375.603,166.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5D3AC"
    },
    d: "M381.492,176.157c-0.169,4.032-0.91,8.054-1.587,12.034c-0.317,1.895-0.699,3.884-0.889,5.842 c-0.085,0.836-0.127,1.662-0.116,2.477c0,0.169,0.254,0.963,0.603,1.873l0.085,0.773l-2.286,3.175 c-0.677,0.053-1.323,0.19-1.831,0.593c-0.974,0.751-1.979,2.392-3.059,3.757c-1.122,1.429-2.318,2.551-3.63,2.053 c-2.455-0.942-3.736-4.72-4.646-6.932c-0.127-0.296-0.243-0.624-0.095-0.91c0.127-0.222,0.381-0.349,0.603-0.476 c2.551-1.461,2.307-3.292,1.715-5.535c-0.032-0.116-0.064-0.233-0.095-0.36c-0.021-0.106-0.053-0.212-0.085-0.307 c-0.307-0.286-0.709-0.402-1.143-0.487c-0.529-0.095-1.101-0.127-1.609-0.265c-1.789-0.497-2.593-2.307-3.122-3.905 c-0.593-1.757-1.143-3.546-1.291-5.387c-0.095-1.312,0.011-2.625,0.127-3.937c0.275-3.207,0.085-5.885-0.159-8.964 c-0.222-2.868,1.947-5.99,4.561-7.536c1.196-0.709,2.54-1.185,3.916-1.556c0.794-0.212,1.609-0.402,2.445-0.444 c1.831-0.116,3.641,0.444,5.228,1.259C380.656,165.859,381.725,170.939,381.492,176.157z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3A9E"
    },
    d: "M361.697,179.424c0,0.511-0.264,0.926-0.589,0.926s-0.589-0.415-0.589-0.926 c0-0.512,0.264-0.926,0.589-0.926S361.697,178.912,361.697,179.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3A9E"
    },
    d: "M367.802,179.424c0,0.511-0.264,0.926-0.589,0.926c-0.325,0-0.589-0.415-0.589-0.926 c0-0.512,0.264-0.926,0.589-0.926C367.538,178.498,367.802,178.912,367.802,179.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF9B72",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M362.12,182.281 c-0.268,0.977-0.536,1.954-0.804,2.931c-0.027,0.097-0.053,0.197-0.039,0.297c0.047,0.329,0.464,0.433,0.795,0.46"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FF9B72",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M361.566,188.281 c1.126,0.574,2.531,0.565,3.649-0.024"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F3A9E",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M360.133,176.257 c0.37-0.39,0.931-0.588,1.464-0.518"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F3A9E",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M366.634,175.96 c0.771-0.236,1.611,0.075,2.119,0.68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075139550499060378150000012742935300329032080_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.0349,
    y1: 199.6738,
    x2: 379.5874,
    y2: 199.6738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5D3AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075139550499060378150000012742935300329032080_)"
    },
    d: "M379.587,199.155l-2.286,3.175 c-0.677,0.053-1.323,0.19-1.831,0.593c-0.974,0.751-1.979,2.392-3.059,3.757c-1.249-2.921-4.022-9.197-6.054-11.801 c-0.032-0.116-0.064-0.233-0.095-0.36c-0.021-0.106-0.053-0.212-0.085-0.307c-0.307-0.286-0.709-0.402-1.143-0.487 c4.17,0.529,13.833-1.058,13.833-1.058l0.148,1.365l0.487,4.35L379.587,199.155z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065070243314278113260000010866703069809816713_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.0181,
    y1: 269.2329,
    x2: 392.7391,
    y2: 269.2329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8BFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6173,
    style: {
      stopColor: "#B4B4FF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065070243314278113260000010866703069809816713_)"
    },
    points: "392.739,272.293  364.965,245.225 348.018,265.938 374.615,293.241  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5D3AC"
    },
    d: "M372.091,272.674c-1.252,1.508-3.356,1.898-5.182,2.611c-2.575,1.005-4.766,2.775-6.911,4.519 c-0.393,0.32,1.782,0.851,1.858,0.861c0.26,0.036,0.537,0.07,0.775-0.041c0.185-0.086,0.32-0.249,0.457-0.401 c0.924-1.023,2.2-1.721,3.56-1.949c-0.179,0.867-0.533,1.607-1.128,2.247c-0.229,0.246-1.758,1.674-1.551,1.999 c-0.362-0.567-0.933-0.996-1.579-1.185c-0.276,1.352-0.552,2.703-0.829,4.055c-0.068,0.333-0.133,0.692,0.009,1 c0.326,0.706,1.421,0.62,1.941,1.198c0.179,0.199,0.281,0.471,0.503,0.621c0.215,0.146,0.493,0.145,0.752,0.159 c1.216,0.07,2.354,0.602,3.55,0.833c1.196,0.23,2.621,0.061,3.324-0.933c0.271-0.383,0.401-0.844,0.534-1.293 c1.123-3.795,2.756-7.439,4.843-10.802L372.091,272.674z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093856630667168008340000004423939378563131265_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.3569,
    y1: 242.1841,
    x2: 399.0517,
    y2: 242.1841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093856630667168008340000004423939378563131265_)"
    },
    d: "M398.685,223.439 c0.432,4.54,0.398,9.114,0.316,13.705c-0.147,8.186-1.672,14.926-5.562,22.26c-3.986,7.474-9.541,14.271-15.828,19.851 c-0.171,0.152-0.359,0.311-0.586,0.329c-0.27,0.022-0.51-0.161-0.717-0.335c-2.479-2.089-4.38-4.525-6.949-6.507 c5.443-8.163,11.337-16.062,14.626-25.484c3.035-8.693,2.364-19.089,2.247-28.162c-0.037-2.894-1.886-15.048,3.179-14.277 c0.27,0.041,0.54,0.094,0.81,0.17c4.936,1.355,6.308,6.9,7.319,11.243C398.094,218.622,398.455,221.025,398.685,223.439z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080895893247125457350000002060541565840811949_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.9302,
    y1: 217.6,
    x2: 364.8901,
    y2: 217.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080895893247125457350000002060541565840811949_)"
    },
    d: "M364.89,234.81 c-3.78-8.61-5.81-20.65-5.81-20.65l2.91-2.73l-3.78-4.24l-0.28-0.31l0.7-0.65l5.36-5l0.9-0.84c0,0-0.01,0.28-0.04,0.8 C364.63,205.72,363.6,228.26,364.89,234.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121273203220964699320000012229551381137962391_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.8901,
    y1: 217.795,
    x2: 384.2002,
    y2: 217.795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121273203220964699320000012229551381137962391_)"
    },
    d: "M380.8,210.44l0.75,7.16l-16.66,17.21 c5.98-9.1,13.76-28.65,15.51-33.11c0.23-0.59,0.35-0.92,0.35-0.92l0.52,1.2l2.93,6.77L380.8,210.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008111275549621943050000017709935116379200138_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.1898,
    y1: 210.7329,
    x2: 365.8148,
    y2: 204.3579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8BFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4B4FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008111275549621943050000017709935116379200138_)"
    },
    d: "M366.793,197.18 c0.158,1.548,0.114,3.364,0.346,4.91c0.369,2.466,0.895,4.909,1.575,7.308c-1.306-0.612-2.419-1.627-3.15-2.87 c0.007,0.34-0.212,0.638-0.42,0.907c-0.98,1.265-1.96,2.53-2.94,3.795c-0.49-1.842-0.5-3.81-0.03-5.657 c0.541-2.125,1.392-4.185,1.968-6.296c0.921-3.375,2.4-3.277,2.4-3.277C366.63,196.463,366.745,196.706,366.793,197.18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111149844181234271610000008944019997220423844_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.3039,
    y1: 203.0663,
    x2: 383.2414,
    y2: 204.1913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8BFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4B4FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111149844181234271610000008944019997220423844_)"
    },
    d: "M380.607,201.075 c0.215-2.072-0.183-4.969-2.175-6.102c-0.26,1.495-0.267,2.907-0.906,4.292c-0.655,1.419-1.5,2.746-2.45,3.984 c-1.685,2.195-3.694,4.115-5.695,6.027c1.192-0.093,2.363-0.44,3.413-1.012c0.301-0.164,0.611-0.352,0.954-0.353 c0.513-0.001,0.923,0.406,1.268,0.787c1.151,1.27,2.278,2.561,3.381,3.873c0.054-1.971,0.331-3.936,0.825-5.844 C379.709,204.846,380.407,203.007,380.607,201.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039818754402816513620000006086463789447087010_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.7358,
    y1: 179.4237,
    x2: 385.8864,
    y2: 179.4237
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5457D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#302C8B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039818754402816513620000006086463789447087010_)"
    },
    d: "M371.188,159.6 c-1.379-0.016-2.708,0.18-3.86,0.612c-1.987,0.745-3.734,2.021-5.327,3.423c-1.012,0.891-1.989,1.86-2.62,3.051 c-0.63,1.192-0.876,2.647-0.382,3.901c0.62,1.575,2.245,2.52,3.855,3.04c2.33,0.753,4.862,1.229,7.065,2.24 c1.042,0.478,1.715,1.517,2.156,2.576c0.763,1.832,0.995,3.839,1.098,5.821c0.178,3.407-0.061,7.031-1.977,9.854 c-1.126,1.659-2.85,3.128-2.949,5.13c2.29-1.408,5.083-1.637,7.748-1.992c2.665-0.355,5.485-0.963,7.37-2.88 c1.664-1.692,2.316-4.146,2.48-6.513c0.116-1.68,0.013-3.406-0.601-4.974c-0.419-1.071-1.066-2.043-1.453-3.126 c-0.676-1.893-0.509-3.965-0.463-5.975c0.083-3.622-0.357-7.512-2.698-10.277C378.564,161.074,374.712,159.642,371.188,159.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonImg);
export default __webpack_public_path__ + "static/media/personImg.d4dd49c7491ecdf7973f29b55797c40b.svg";
export { ForwardRef as ReactComponent };